const cities = [
  { name: "Russellville", zips: "72801, 72802" },
  { name: "Dover", zips: "72837" },
  { name: "Dardanelle", zips: "72834" },
  { name: "Morrilton", zips: "72110" },
  { name: "Clarksville", zips: "72830" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your home or office in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function RussellvilleLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Russellville &amp; the Arkansas River Valley
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Russellville, Arkansas sits at the heart of the Arkansas River Valley — halfway between Little Rock and Fort Smith on I-40, flanked by the Ozark and Ouachita mountain ranges, and home to Lake Dardanelle, the Arkansas River, and one of the state's most distinctive economic profiles. The city is both an educational hub and an energy industry center, and the combination creates a passport urgency pattern that is far more compressed than most similarly-sized Arkansas communities.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Arkansas Tech University brings over 12,000 students to Russellville, with a growing international education office that dispatches students to Europe, Latin America, and Asia. Study-abroad program deadlines in October and February routinely catch first-time applicants off guard — students who have never needed a passport before are suddenly scrambling to submit applications before orientation. Standard post office processing cannot meet those timelines, and the nearest passport agency in Little Rock requires a documented appointment. Fast Passport Center fills that gap with professional, guided expedited service that students, parents, and faculty can rely on.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The Arkansas Nuclear One plant — the only operating nuclear power station in Arkansas, located just outside Russellville in Russellville — employs hundreds of engineers and nuclear professionals who travel internationally for training, regulatory seminars, and industry conferences. The International Atomic Energy Agency, nuclear energy conferences in France and Japan, and peer plant visits in South Korea and Germany create a steady stream of short-notice passport needs for credentialed professionals with non-negotiable meeting schedules.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Russellville also has an active church and nonprofit mission community. Dozens of churches in Pope County send mission teams to Central America, Southeast Asia, and sub-Saharan Africa annually — often with application windows of two to four weeks before departure. Add outdoor enthusiasts heading for international hiking and kayaking expeditions in Patagonia, Scotland, and New Zealand, and the demand picture becomes clear. Fast Passport Center removes the geographic disadvantage of being 100 miles from Little Rock and 120 miles from Fort Smith, delivering the same professional expedited service available in any major Arkansas city.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Russellville, AR</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving Pope County &amp; the Arkansas River Valley</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-5 leading-relaxed">
                After signing up online, ship your documents overnight to us — no office visit required for most services. We review, submit, and handle every detail while you focus on your ATU coursework, nuclear plant schedule, or mission preparation.
              </p>
              <a
                href="https://fastpassportcenter.com/checkout/"
                className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
              >
                Start My Passport <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in the Arkansas River Valley — start online, ship overnight, and we handle the rest. No need to drive to Little Rock or Fort Smith for a passport agency appointment.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Little Rock", href: "/cities/little-rock" },
                    { name: "Fort Smith", href: "/cities/fort-smith" },
                    { name: "Conway", href: "/cities/conway" },
                    { name: "Benton", href: "/cities/benton" },
                    { name: "Hot Springs", href: "/cities/hot-springs" },
                    { name: "Fayetteville", href: "/cities/fayetteville-ar" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why River Valley Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}